var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (facets, ignoreExclusive, origin) {pug_mixins["questionMarkTooltip"] = pug_interp = function(facet){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cbutton class=\"button button-text question-mark-tooltip circular align-middle\" type=\"button\" data-component=\"tooltip\" data-placement=\"top\" data-tooltip=\"[data-question-tooltip]\"\u003E?\u003Cdiv class=\"clickable-tooltip tooltip\" data-question-tooltip x-placement=\"top\"\u003E" + (pug.escape(null == (pug_interp = facet.description) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fbutton\u003E";
};
const shouldIgnoreExclusive = ignoreExclusive ? 1 : 0
// iterate facets
;(function(){
  var $$obj = facets;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var facet = $$obj[pug_index0];
if (!facet.options || facet.options.length === 0) {
continue
}
const isExpandable = facet.options.length > 5
const readableName = facet.readableName
const isURL = facet.isUrl ? 1 : 0
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([`${ isExpandable ? 'margin-bottom-double' : 'margin-bottom' }`], [true]), false, true)) + "\u003E\u003Cdiv class=\"heading-5 strong color-neutral margin-y-small align-middle\"\u003E" + (pug.escape(null == (pug_interp = readableName) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
if (facet.description) {
pug_html = pug_html + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp));
pug_mixins["questionMarkTooltip"](facet);
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([`${ isExpandable ? 'expandable-product-list-filter' : '' }`], [true]), false, true)) + "\u003E\u003Cdiv" + (pug.attr("class", pug.classes(["group-list","product-filter",`${ isExpandable ? 'collapse' : '' }`], [false,false,true]), false, true)+pug.attr("data-facet-overlay-expandable", facet.name, true, true)) + "\u003E";
// iterate facet.options
;(function(){
  var $$obj = facet.options;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var option = $$obj[pug_index1];
const amount = option.quantity
const filterKey = facet.name.toLowerCase()
const title = option.title
const filterQuery = "filter["+ filterKey +"]="+ option.name
if (amount > 0) {
pug_html = pug_html + "\u003Ca" + (" class=\"item\""+" href=\"#\" data-component=\"entry-key\u002Fproducts-filter\""+pug.attr("data-query", filterQuery, true, true)+pug.attr("data-exclusive-url", isURL, true, true)+pug.attr("data-origin", origin, true, true)+pug.attr("data-facet", readableName.toLowerCase(), true, true)+pug.attr("data-ignore-exclusive-url", shouldIgnoreExclusive, true, true)+pug.attr("title", title, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = title) ? "" : pug_interp)) + "\u003Cspan class=\"color-default small\"\u003E (" + (pug.escape(null == (pug_interp = amount) ? "" : pug_interp)) + ")\u003C\u002Fspan\u003E\u003C\u002Fa\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var option = $$obj[pug_index1];
const amount = option.quantity
const filterKey = facet.name.toLowerCase()
const title = option.title
const filterQuery = "filter["+ filterKey +"]="+ option.name
if (amount > 0) {
pug_html = pug_html + "\u003Ca" + (" class=\"item\""+" href=\"#\" data-component=\"entry-key\u002Fproducts-filter\""+pug.attr("data-query", filterQuery, true, true)+pug.attr("data-exclusive-url", isURL, true, true)+pug.attr("data-origin", origin, true, true)+pug.attr("data-facet", readableName.toLowerCase(), true, true)+pug.attr("data-ignore-exclusive-url", shouldIgnoreExclusive, true, true)+pug.attr("title", title, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = title) ? "" : pug_interp)) + "\u003Cspan class=\"color-default small\"\u003E (" + (pug.escape(null == (pug_interp = amount) ? "" : pug_interp)) + ")\u003C\u002Fspan\u003E\u003C\u002Fa\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (isExpandable) {
pug_html = pug_html + "\u003Cdiv class=\"group-list\"\u003E\u003Cdiv class=\"line-around small margin-bottom\"\u003E\u003Cdiv" + (" class=\"link hidden\""+" data-component=\"live-collapse\""+pug.attr("data-target", `[data-facet-overlay-expandable=${ facet.name }]`, true, true)) + "\u003E\u003Cdiv class=\"line-wrapper\"\u003E\u003Cspan class=\"hidden-active\"\u003EVer mais\u003C\u002Fspan\u003E\u003Cspan class=\"visible-active\"\u003EVer menos\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var facet = $$obj[pug_index0];
if (!facet.options || facet.options.length === 0) {
continue
}
const isExpandable = facet.options.length > 5
const readableName = facet.readableName
const isURL = facet.isUrl ? 1 : 0
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([`${ isExpandable ? 'margin-bottom-double' : 'margin-bottom' }`], [true]), false, true)) + "\u003E\u003Cdiv class=\"heading-5 strong color-neutral margin-y-small align-middle\"\u003E" + (pug.escape(null == (pug_interp = readableName) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
if (facet.description) {
pug_html = pug_html + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp));
pug_mixins["questionMarkTooltip"](facet);
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([`${ isExpandable ? 'expandable-product-list-filter' : '' }`], [true]), false, true)) + "\u003E\u003Cdiv" + (pug.attr("class", pug.classes(["group-list","product-filter",`${ isExpandable ? 'collapse' : '' }`], [false,false,true]), false, true)+pug.attr("data-facet-overlay-expandable", facet.name, true, true)) + "\u003E";
// iterate facet.options
;(function(){
  var $$obj = facet.options;
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var option = $$obj[pug_index2];
const amount = option.quantity
const filterKey = facet.name.toLowerCase()
const title = option.title
const filterQuery = "filter["+ filterKey +"]="+ option.name
if (amount > 0) {
pug_html = pug_html + "\u003Ca" + (" class=\"item\""+" href=\"#\" data-component=\"entry-key\u002Fproducts-filter\""+pug.attr("data-query", filterQuery, true, true)+pug.attr("data-exclusive-url", isURL, true, true)+pug.attr("data-origin", origin, true, true)+pug.attr("data-facet", readableName.toLowerCase(), true, true)+pug.attr("data-ignore-exclusive-url", shouldIgnoreExclusive, true, true)+pug.attr("title", title, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = title) ? "" : pug_interp)) + "\u003Cspan class=\"color-default small\"\u003E (" + (pug.escape(null == (pug_interp = amount) ? "" : pug_interp)) + ")\u003C\u002Fspan\u003E\u003C\u002Fa\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var option = $$obj[pug_index2];
const amount = option.quantity
const filterKey = facet.name.toLowerCase()
const title = option.title
const filterQuery = "filter["+ filterKey +"]="+ option.name
if (amount > 0) {
pug_html = pug_html + "\u003Ca" + (" class=\"item\""+" href=\"#\" data-component=\"entry-key\u002Fproducts-filter\""+pug.attr("data-query", filterQuery, true, true)+pug.attr("data-exclusive-url", isURL, true, true)+pug.attr("data-origin", origin, true, true)+pug.attr("data-facet", readableName.toLowerCase(), true, true)+pug.attr("data-ignore-exclusive-url", shouldIgnoreExclusive, true, true)+pug.attr("title", title, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = title) ? "" : pug_interp)) + "\u003Cspan class=\"color-default small\"\u003E (" + (pug.escape(null == (pug_interp = amount) ? "" : pug_interp)) + ")\u003C\u002Fspan\u003E\u003C\u002Fa\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (isExpandable) {
pug_html = pug_html + "\u003Cdiv class=\"group-list\"\u003E\u003Cdiv class=\"line-around small margin-bottom\"\u003E\u003Cdiv" + (" class=\"link hidden\""+" data-component=\"live-collapse\""+pug.attr("data-target", `[data-facet-overlay-expandable=${ facet.name }]`, true, true)) + "\u003E\u003Cdiv class=\"line-wrapper\"\u003E\u003Cspan class=\"hidden-active\"\u003EVer mais\u003C\u002Fspan\u003E\u003Cspan class=\"visible-active\"\u003EVer menos\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);
}.call(this,"facets" in locals_for_with?locals_for_with.facets:typeof facets!=="undefined"?facets:undefined,"ignoreExclusive" in locals_for_with?locals_for_with.ignoreExclusive:typeof ignoreExclusive!=="undefined"?ignoreExclusive:undefined,"origin" in locals_for_with?locals_for_with.origin:typeof origin!=="undefined"?origin:undefined));;return pug_html;};
module.exports = template;